// controls CSS animation speed
export const ANIMATION_DURATION = 2500;
export const NOTIFICATION_LIFETIME = 2500;
export const ERROR_NOTIFICATION_LIFETIME = 2500;
export const ERROR_TYPE = 'error';
